import * as angular from 'angular';
import sponsorsRouter from './sponsors.router';
import sponsorService from './sponsor.service';

import { SPONSOR_TYPES, SPONSOR_STATUSES } from './sponsors.constants';

import countryService from 'app/common/services/country.service';
import DestinationService from 'app/common/services/destination.service';
import merchantService from 'app/merchants/merchant.service';
import merchantCategoriesService from 'app/merchants/merchant-categories.service';

/** @constant {angular.module} */
const sponsorsModule = angular
  .module('ec.opsCenter.sponsors', [])
  .config(sponsorsRouter)
  .service('sponsorService', sponsorService)
  .service('countryService', countryService)
  .service('DestinationService', DestinationService)
  .service('merchantService', merchantService)
  .service('merchantCategoriesService', merchantCategoriesService)
  .factory('SPONSOR_TYPES', SPONSOR_TYPES)
  .factory('SPONSOR_STATUSES', SPONSOR_STATUSES).name;

export default sponsorsModule;



// WEBPACK FOOTER //
// ./src/app/sponsors/sponsors.module.ts